import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { ItemProps } from '../types';

export const Item = React.memo(({ ref, ...props }: ItemProps) => {
  useEffect(() => {
    if (!props.dragOverlay) {
      return;
    }

    document.body.style.cursor = 'grabbing';

    return () => {
      document.body.style.cursor = '';
    };
  }, [props.dragOverlay]);

  const listeners = !props.handle ? props.listeners : {};

  return props.renderItem ? (
    props.renderItem({
      disabled: Boolean(props.disabled),
      dragging: Boolean(props.dragging),
      dragOverlay: Boolean(props.dragOverlay),
      fadeIn: Boolean(props.fadeIn),
      listeners: props.listeners,
      ref,
      sorting: Boolean(props.sorting),
      value: props.value,
    })
  ) : (
    <Box ref={ref}>
      <Box
        style={props.style}
        data-cypress="draggable-item"
        tabIndex={!props.handle ? 0 : undefined}
        {...listeners}
      >
        {props.children && <>{props.children}</>}
      </Box>
    </Box>
  );
});
